export default {
  // Sidebar
  changeFormItem(state, formItems){
    state.formItems = formItems
  },
  changeSidebarMiniVariant(state, newValue){
    state.sidebarMiniVariant = newValue
  },

  changeDrawerState(state, newValue){
    state.drawerState = newValue
  },

  // Breadcrumbs
  changeBreadcrumbs(state, breadcrumbs){
    state.breadcrumbs = breadcrumbs
  },
  pushBreadcrumb(state, breadcrumb){
    state.breadcrumbs.push(breadcrumb)
  },
  unshiftBreadcrumb(state, breadcrumb){
    state.breadcrumbs.unshift(breadcrumb)
  },

  // Toolbar
  changePageTitle(state, pageTitle){
    state.pageTitle = pageTitle
  },

  // Snackbar Mutations
  showSnackbar(state, payload){
    state.snackbar.text = payload.text
    state.snackbar.multiline = payload.text.length > 100

    if (payload.multiline) state.snackbar.multiline = payload.multiline
    if (payload.timeout) state.snackbar.timeout = payload.timeout
    if (payload.color) state.snackbar.color = payload.color

    state.snackbar.visible = true
  },
  closeSnackbar(state){
    state.snackbar.visible = false
    state.snackbar.multiline = false
    state.snackbar.timeout = 3000
    state.snackbar.color = ''
    state.snackbar.text = null
  },
  
  // Loading
  showLoading(state, payload){
    state.loading.visible = true
    state.loading.text = payload.text
    if (payload.color) state.loading.color = payload.color
    if (payload.width) state.loading.width = payload.width
  },
  closeLoading(state){
    state.loading.visible = false
    state.loading.text = null
    state.loading.color = 'white'
    state.loading.width = 0.2
  }
}
